import React, { Component, Fragment } from 'react'
import { animateScroll as scroll } from 'react-scroll'

import is from '../../utils/is'
import IconArrowUp from '../icon/IconArrowUp'
import styles from './backToTop.module.css'

export default class BackToTop extends Component {
  constructor(props) {
    super(props)
    this.buttonId = 'back-to-top'
  }

  bindEvents() {
    if (!is.window) {
      window.addEventListener('scroll', this.onScroll.bind(this), false)
    }
  }

  unBindEvents() {
    if (!is.window) {
      window.removeEventListener('scroll', this.onScroll.bind(this), false)
    }
  }

  onScroll() {
    const canShowBackToTop =
      (!is.document && document.body.scrollTop > 20) ||
      (!is.document && document.documentElement.scrollTop > 20)

    if (canShowBackToTop) {
      document.getElementById(this.buttonId).style.display = 'block'
    } else {
      document.getElementById(this.buttonId).style.display = 'none'
    }
  }

  goToTopAndRemoveHash() {
    scroll.scrollToTop()
  }

  componentDidMount() {
    this.bindEvents()
  }

  componentWillUnmount() {
    this.unBindEvents()
  }

  render() {
    return (
      <Fragment>
        <button
          id={this.buttonId}
          className={styles.button}
          onClick={this.goToTopAndRemoveHash}
        >
          <IconArrowUp color={'white'} />
        </button>
      </Fragment>
    )
  }
}
